import ActionTypes from "../constants/action_types";

export default function clearReports() {
  return {
    type: ActionTypes.REPORTS_CLEAR.SUCCESS,
  };
}
